import {IGridData} from '../../ap-interface';
import IFertilizerInorg = Data.BaseData.IFertilizerInorg;

export enum InorganicFertilizerActions {
  Active = 0,
  Inactive = 1
}

export interface IFertilizerInorganicGridData extends IGridData<IFertilizerInorg> {
  Status: number;
  StatusClass: string;
  StatusDesc: string;
  CaOValue: any;
  KValue: any;
  MGValue: any;
  NValue: any;
  PValue: any;
  SValue: any;
  Efficiency: any;
  EquivCaO: any;
  Liquid: any;
  Density: any;
  Unit: any;
  RealContentCaO: any;
}
